<template>
  <section class="adminList">
    <v-container fluid>
      <v-layout>
        <v-flex md12>
          <material-card>
            <v-layout layout row justify-space-between>

              <v-flex
                xs12
                sm5
                md5>
                <v-text-field
                  v-model="search"
                  append-outer-icon="search"
                  label="Search"
                  clearable
                  :disabled="loadingData"
                  @click:clear="clearSearch"
                  @click:append-outer="searchAll(search)"
                  @keyup.enter="searchAll(search)"
                />
              </v-flex>
              <!-- <v-flex
                xs12
                sm3
                md3>
                <v-btn
                  class="search-btn"
                  color="orange"
                  @click="searchAll(search)">
                  Search
                </v-btn>
              </v-flex> -->
              <v-flex
                xs12
                sm3
                md3 offset-md7 align-end>
                <v-checkbox
                  v-model="listArchived"
                  label="Archived"
                  @change="toggleAllArchived($event)"
                />
              </v-flex>
            </v-layout>
            <v-data-table
              :headers="adminListHeaders"
              :items="adminWorkloadList"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              disable-initial-sort
              hide-actions
            >
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="subheading font-weight-light text-success text-md-left text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <td>

                  <router-link
                    v-if="$can('manage', 'oppreg')"
                    :to="'/admin/oppreg-administration/admin-content/' + props.item.Project_Id"
                    tag="div"
                    class="view-link"
                    title="View" >
                    <v-icon
                      color="orange"
                      class="mr-2"
                      title="View Workload">
                      visibility
                    </v-icon>
                  </router-link>
                  
                  <span v-else>
                    <v-icon
                      disabled
                      color="orange"
                      class="mr-2"
                      title="View Workload">
                      visibility
                    </v-icon>
                  </span> 

                  <!-- <can
                    i="manage"
                    a="oppreg">
                    <router-link
                      :to="'/admin/oppreg-administration/admin-content/' + props.item.Project_Id"
                      tag="div"
                      class="view-link"
                      title="View" >
                      <v-icon
                        color="orange"
                        class="mr-2"
                        title="View Workload">
                        visibility
                      </v-icon>
                    </router-link>
                  </can> -->
                </td>
                <!-- <td>{{ props.item.Project_Id }}</td> -->
                <td>{{ props.item.SFDC_Id }}</td>
                <!-- <td>{{ props.item.Opportunity_Number }}</td> -->
                <td>{{ props.item.Workload_Title }}</td>
                <td>{{ props.item.Customer_Name }}</td>
                <td>{{ props.item.OppReg_Req_Date }}</td>
                <td>{{ props.item.Workload_Status }}</td>
                <td>{{ props.item.Workload_type }}</td>
                <td>{{ props.item.Campaign_Name }}</td>
                <td>{{ props.item.Requestor_Email }}</td>
                <td>{{ props.item.AWS_ACE_ID }}</td>
                <td>{{ props.item.Global_Registered }}</td>
              </template>
            </v-data-table>
            <v-progress-linear
              v-slot:progress
              v-if="loadingData"
              color="orange"
              indeterminate/>
            <div class="text-xs-center mt-3" >
              <v-btn :disabled="!adminNextPageKey" small @click="showNextData">LOAD MORE...</v-btn>
            </div>
          </material-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import { mapMutations, mapState, mapActions } from 'vuex'

export default {
  data () {
    return {
      search: '',
      rowsPerPageItems: [10, 20, 30, 40],
      pagination: {
        rowsPerPage: 10,
        sortBy: 'Project_Id',
        descending: true,
        size: 10
      },
      listArchived: false
    }
  },
  computed: {
    // ...mapState('admin/oppregAdmin', ['masterWorkloads', 'adminListHeaders']),
    // filterWorkloads () {
    //   return this.masterWorkloads
    // }
    ...mapState('admin/oppregAdmin', ['adminWorkloadList', 'adminListHeaders', 'adminNextPageKey', 'loadingData'])
  },
  watch: {
    // search (value) {
    //   console.log('search', value)
    //   this.$store.dispatch('admin/oppregAdmin/clearAdminWorkloadList')
    //   if (this.listArchived) {
    //     if (value) {
    //       this.$store.dispatch('admin/oppregAdmin/getListArchive', { size: this.pagination.size, isList: this.listArchived, saerchAll: value })
    //     } else {
    //       this.$store.dispatch('admin/oppregAdmin/getListArchive', { size: this.pagination.size, isList: this.listArchived })
    //     }
    //   } else {
    //     if (value) {
    //       this.$store.dispatch('admin/oppregAdmin/getOppRegAdminListData', { size: this.pagination.size, searchAll: value })
    //     } else {
    //       this.$store.dispatch('admin/oppregAdmin/getOppRegAdminListData', { size: this.pagination.size })
    //     }
    //   }
    // },
    // listArchived (value) {
    //   console.log('listArchived', value)
    //   if (value) {
    //     this.$store.dispatch('admin/oppregAdmin/getListArchive', { size: this.pagination.size, Opportunity_Id: value })
    //   } else {
    //     this.$store.dispatch('admin/oppregAdmin/getListArchive', { size: this.pagination.size })
    //   }
    // }
  },
  mounted () {
    this.$store.dispatch('admin/oppregAdmin/clearAdminWorkloadList')
    this.$store.dispatch('admin/oppregAdmin/getOppRegAdminListData', { size: this.pagination.size })
  },
  methods: {
    toggleAllArchived () {
      this.search = ''
      this.searchCustomerName = ''
      this.searchAceId = ''
      this.searchRegion = ''
      this.searchStatus = ''
      let params = {
        size: this.pagination.size,
        isList: this.listArchived
      }
      if (this.nextArchivedPageKey) {
        params.nextArchivedPageKey = this.nextArchivedPageKey
      }
      if (this.search) {
        params.searchAll = this.search
      }
      this.$store.dispatch('admin/oppregAdmin/getListArchive', params)
    },
    showNextData () {
      console.log('adminWorkloadList', this.adminWorkloadList.length)
      this.pagination.rowsPerPage = this.adminWorkloadList.length + this.pagination.rowsPerPage
      console.log('showNextData', this.pagination.rowsPerPage)
      let params = {
        size: this.pagination.size
      }
      if (this.adminNextPageKey) {
        params.nextPageKey = this.adminNextPageKey
      }
      if (this.search) {
        params.searchAll = this.search
      }
      if (this.listArchived) {
        params.isList = this.listArchived
        this.$store.dispatch('admin/oppregAdmin/getListArchive', params)
      } else {
        this.$store.dispatch('admin/oppregAdmin/getOppRegAdminListData', params)
      }
    },
    searchAll (value) {
      console.log('search', value)
      this.$store.dispatch('admin/oppregAdmin/clearAdminWorkloadList')
      if (this.listArchived) {
        if (value) {
          this.$store.dispatch('admin/oppregAdmin/getListArchive', { size: this.pagination.size, isList: this.listArchived, searchAll: value })
        } else {
          this.$store.dispatch('admin/oppregAdmin/getListArchive', { size: this.pagination.size, isList: this.listArchived })
        }
      } else {
        if (value) {
          this.$store.dispatch('admin/oppregAdmin/getOppRegAdminListData', { size: this.pagination.size, searchAll: value })
        } else {
          this.$store.dispatch('admin/oppregAdmin/getOppRegAdminListData', { size: this.pagination.size })
        }
      }
    },
    clearSearch () {
      this.search = ''
      this.$store.dispatch('admin/oppregAdmin/clearAdminWorkloadList')
      if (this.listArchived) {
        this.$store.dispatch('admin/oppregAdmin/getListArchive', { size: this.pagination.size, isList: this.listArchived })
      } else {
        this.$store.dispatch('admin/oppregAdmin/getOppRegAdminListData', { size: this.pagination.size })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
#search-wrapper {
  padding:35px 0  0 0;
  margin:15px 15px;
  background: #2196f3;

  .v-btn {
    margin: 3px 0 !important
 }
//   .search-btn .v-btn__content{
//   // color: #fff !important
// }

.v-btn .v-btn__content {
  color: #fff;
  background-color: none;
  box-shadow: none;
  font-weight: 500;
}
}
.v-btn-search .v-btn__content {
    align-items: center;
    border-radius: inherit;
    color: inherit;
    display: flex;
    flex: 1 0 auto;
    justify-content: center;
    margin: 0 auto;
    position: relative;
    transition: .3s cubic-bezier(.25,.8,.5,1);
    white-space: nowrap;
    width: inherit;
}
.view-link {
    cursor:pointer;
    color: #ff9900 !important
  }

section.adminList{
  table.v-table thead th {
  font-weight: 600
 }

 .v-datatable thead th {
   background-color: #2196f3;
   color: #fff;
   font-weight: 400;

   span{
    //  color: #fff !important;
     font-size:14px !important;
     font-weight:500 !important
   }
 }
}

</style>
